import { MainCategoriesEnum, ProductNameEnum, } from "../types/index.js";
import { populatePrice, reduceToUID, } from "../utils/index.js";
import { PROPULSION_01, PROPULSION_02, PROPULSION_04, PROPULSION_05, PROPULSION_06, PROPULSION_07, PROPULSION_08, PROPULSION_09, } from "./propulsion.js";
import { EXTRA_01, 
//EXTRA_03,
EXTRA_04, EXTRA_06, EXTRA_07, EXTRA_08, EXTRA_09, EXTRA_10, EXTRA_11, EXTRA_13, EXTRA_14, EXTRA_15, EXTRA_16, EXTRA_17, EXTRA_18, 
//EXTRA_20,
EXTRA_21, EXTRA_22, EXTRA_24, EXTRA_25, EXTRA_26, } from "./extras.js";
import { FABRICS_02, FABRICS_04, FABRICS_13, FABRICS_ALL } from "./fabrics.js";
import { TEAK_05, TEAK_06, TEAK_ALL } from "./teak.js";
import { HULL_18, HULL_22, HULL_24, HULL_ALL } from "./hull.js";
export const MAIN_CATEGORIES = Object.values(MainCategoriesEnum).map((category) => ({
    uid: reduceToUID(category),
    name: category === "flooring" ? "Flooring" : category,
}));
export const TRICKY_COMMANDS = {
    [ProductNameEnum.SAY52]: {
        /* reset_camera */
        pathName: "/say52",
        change_model: "say_52_visible",
        pdf_hero_camera: "say52_pdf_hero",
        camera_view: [
            "say_52_3/4 top" /* hero banner / form preview */,
            "say_52_teak_hull" /* 1 */,
            "say_52_sunlounge_teak" /* 2 */,
            "say_52_cockpit" /* 3 */,
            "say_52_top" /* 4 */,
            "say_52_seats" /* 5 */,
            "say_52_lounge_table" /* 6 */,
            "say_52_3/4 top" /* 7 */,
            "say_52_bow" /* 8 */,
        ],
    },
    [ProductNameEnum.SAY42SPORT]: {
        pathName: "/say42sport",
        change_model: "say_42_sport_visible",
        pdf_hero_camera: "say42_sport_pdf_hero",
        camera_view: [
            "say_42_s_3/4 top",
            "say_42_s_teak_hull",
            "say_42_s_sunlounge_teak",
            "say_42_s_cockpit",
            "say_42_s_top",
            "say_42_s_seats",
            "say_42_s_lounge_table",
            "say_42_s_3/4 top",
            "say_42_s_bow",
        ],
    },
    [ProductNameEnum.SAY42]: {
        pathName: "/say42",
        change_model: "say_42_r_visible",
        pdf_hero_camera: "say42_pdf_hero",
        camera_view: [
            "say_42_3/4 top",
            "say_42_teak_hull",
            "say_42_sunlounge_teak",
            "say_42_cockpit",
            "say_42_top",
            "say_42_seats",
            "say_42_lounge_table",
            "say_42_3/4 top",
            "say_42_bow",
        ],
    },
    [ProductNameEnum.SAY32]: {
        pathName: "/say32",
        change_model: "say_32_visible",
        pdf_hero_camera: "say32_pdf_hero",
        camera_view: [
            "say_32_3/4 top",
            "say_32_teak_hull",
            "say_32_sunlounge_teak",
            "say_32_cockpit",
            "say_32_top",
            "say_32_seats",
            "say_32_lounge_table",
            "say_32_3/4 top",
            "say_32_bow",
        ],
    },
};
export const MODELS_DATA = {
    [ProductNameEnum.SAY52]: {
        uid: ProductNameEnum.SAY52,
        title: "SAY 52",
        basePrice: 2048250,
        enabled: true,
    },
    [ProductNameEnum.SAY42SPORT]: {
        uid: ProductNameEnum.SAY42SPORT,
        title: "SAY 42S",
        titleMobile: "SAY 42S",
        basePrice: 1299900,
        enabled: true,
    },
    [ProductNameEnum.SAY42]: {
        uid: ProductNameEnum.SAY42,
        title: "SAY 42",
        basePrice: 1212600,
        enabled: true,
    },
    [ProductNameEnum.SAY32]: {
        uid: ProductNameEnum.SAY32,
        title: "SAY 32",
        basePrice: 484900,
        enabled: true,
    },
};
export const GROUP_RELATIONS = {
    unicolors: {
        uid: "unicolors",
        name: "Classic",
    },
    metallic: {
        uid: "metallic",
        name: "Metallic",
    },
    fabrics_colors: {
        uid: "fabrics_colors",
        name: "Options",
    },
    teak_natural: {
        uid: "teak_natural",
        name: "Natural certified Teak",
    },
    teak_colors: {
        uid: "teak_colors",
        name: "Flexi Teak",
    },
    __unknown__: {
        uid: "__unknown__",
        name: "Other",
    },
};
export const DATA_RELATION = {
    [ProductNameEnum.SAY52]: {
        [MainCategoriesEnum.FABRICS]: {
            type: "texture",
            initialItem: FABRICS_02.uid,
            initialGroup: FABRICS_02.group,
            items: FABRICS_ALL,
        },
        [MainCategoriesEnum.HULL]: {
            type: "texture",
            initialItem: HULL_24.uid,
            initialGroup: HULL_24.group,
            items: HULL_ALL.map((el) => populatePrice(el, { metallic: 40190 })),
        },
        [MainCategoriesEnum.FLOORING]: {
            type: "texture",
            initialItem: TEAK_05.uid,
            initialGroup: TEAK_05.group,
            items: TEAK_ALL.map((el) => el.uid === "teak" ? populatePrice(el, 19940) : populatePrice(el, 0)),
        },
        [MainCategoriesEnum.EXTRAS]: {
            type: "extra",
            items: [
                populatePrice(EXTRA_21, 21400),
                populatePrice(EXTRA_08, 14550),
                populatePrice(EXTRA_07, 7675),
                populatePrice(EXTRA_09, 15290),
                populatePrice(EXTRA_01, 21560),
                populatePrice(EXTRA_22, 3150),
                populatePrice(EXTRA_06, 9880),
                populatePrice(EXTRA_24, 12880),
                populatePrice(EXTRA_11, 11440),
                populatePrice(EXTRA_04, 5690),
                populatePrice(EXTRA_10, 8125),
                populatePrice(EXTRA_26, 0),
            ],
        },
        [MainCategoriesEnum.PROPULSION]: {
            type: "extra",
            initialItem: PROPULSION_01.uid,
            items: [
                populatePrice(PROPULSION_01, 0),
                populatePrice(PROPULSION_02, 158630),
                populatePrice(PROPULSION_07, 173690),
            ],
        },
    },
    [ProductNameEnum.SAY42]: {
        [MainCategoriesEnum.FABRICS]: {
            type: "texture",
            initialItem: FABRICS_13.uid,
            initialGroup: FABRICS_13.group,
            items: FABRICS_ALL,
        },
        [MainCategoriesEnum.HULL]: {
            type: "texture",
            initialItem: HULL_22.uid,
            initialGroup: HULL_22.group,
            items: HULL_ALL.map((el) => populatePrice(el, { metallic: 31845 })),
        },
        [MainCategoriesEnum.FLOORING]: {
            type: "texture",
            initialItem: TEAK_06.uid,
            initialGroup: TEAK_06.group,
            items: TEAK_ALL.map((el) => el.uid === "teak" ? populatePrice(el, 14245) : populatePrice(el, 0)),
        },
        [MainCategoriesEnum.EXTRAS]: {
            type: "extra",
            items: [
                populatePrice(EXTRA_17, 43725),
                populatePrice(EXTRA_18, 12330),
                populatePrice(EXTRA_07, 7340),
                populatePrice(EXTRA_09, 15290),
                populatePrice(EXTRA_06, 5775),
                populatePrice(EXTRA_24, 6830),
                populatePrice(EXTRA_11, 7850),
                populatePrice(EXTRA_04, 2475),
                populatePrice(EXTRA_10, 5975),
            ],
        },
        [MainCategoriesEnum.PROPULSION]: {
            type: "extra",
            initialItem: PROPULSION_04.uid,
            items: [
                populatePrice(PROPULSION_04, 0),
                populatePrice(PROPULSION_05, 44990),
            ],
        },
    },
    [ProductNameEnum.SAY42SPORT]: {
        [MainCategoriesEnum.FABRICS]: {
            type: "texture",
            initialItem: FABRICS_04.uid,
            initialGroup: FABRICS_04.group,
            items: FABRICS_ALL,
        },
        [MainCategoriesEnum.HULL]: {
            type: "texture",
            initialItem: HULL_22.uid,
            initialGroup: HULL_22.group,
            items: HULL_ALL.map((el) => populatePrice(el, { metallic: 31845 })),
        },
        [MainCategoriesEnum.FLOORING]: {
            type: "texture",
            initialItem: TEAK_05.uid,
            initialGroup: TEAK_05.group,
            items: TEAK_ALL.map((el) => el.uid === "teak" ? populatePrice(el, 14245) : populatePrice(el, 0)),
        },
        [MainCategoriesEnum.EXTRAS]: {
            type: "extra",
            items: [
                populatePrice(EXTRA_25, 26450),
                populatePrice(EXTRA_18, 12330),
                populatePrice(EXTRA_07, 7340),
                populatePrice(EXTRA_09, 15290),
                populatePrice(EXTRA_06, 5775),
                populatePrice(EXTRA_24, 6830),
                populatePrice(EXTRA_11, 7850),
                populatePrice(EXTRA_26, 19200),
                populatePrice(EXTRA_04, 2475),
                populatePrice(EXTRA_10, 5975),
            ],
        },
        [MainCategoriesEnum.PROPULSION]: {
            type: "extra",
            initialItem: PROPULSION_04.uid,
            items: [
                populatePrice(PROPULSION_04, 0),
                populatePrice(PROPULSION_08, 44990),
            ],
        },
    },
    [ProductNameEnum.SAY32]: {
        [MainCategoriesEnum.FABRICS]: {
            type: "texture",
            initialItem: FABRICS_04.uid,
            initialGroup: FABRICS_04.group,
            items: FABRICS_ALL,
        },
        [MainCategoriesEnum.HULL]: {
            type: "texture",
            initialItem: HULL_18.uid,
            initialGroup: HULL_18.group,
            items: HULL_ALL.map((el) => populatePrice(el, { metallic: 17500 })),
        },
        [MainCategoriesEnum.FLOORING]: {
            type: "texture",
            initialItem: TEAK_06.uid,
            initialGroup: TEAK_06.group,
            items: TEAK_ALL.map((el) => el.uid === "teak" ? populatePrice(el, 9800) : populatePrice(el, 0)),
        },
        [MainCategoriesEnum.EXTRAS]: {
            type: "extra",
            items: [
                populatePrice(EXTRA_14, 19750),
                populatePrice(EXTRA_15, 6900),
                populatePrice(EXTRA_16, 14600),
                populatePrice(EXTRA_06, 5775),
                populatePrice(EXTRA_24, 4830),
                populatePrice(EXTRA_13, 37800),
                populatePrice(EXTRA_26, 16350),
                populatePrice(EXTRA_04, 2475),
                populatePrice(EXTRA_10, 4975),
            ],
        },
        [MainCategoriesEnum.PROPULSION]: {
            type: "extra",
            initialItem: PROPULSION_09.uid,
            items: [
                populatePrice({ ...PROPULSION_09, emitId: "SAY32_SingleEngine" }, 0),
                populatePrice({ ...PROPULSION_06, emitId: "SAY32_DuoEngine" }, 89100),
            ],
        },
    },
};
export const getDefaultDataByProduct = (productName) => {
    return {
        ...DATA_RELATION[productName],
    };
};
export const getMainCategoryInfo = (productName, category) => {
    return getDefaultDataByProduct(productName)[category];
};
